import StateMaster from "../../components/stateMaster/StateMaster"

function StateMasterPage() {
    return (
        <>
            <StateMaster />
        </>
    )
}
export default StateMasterPage